<template>
  <div
    class="ui-chip align-center"
    :class="{
      'ui-chip--selected': selected,
      [`ui-chip-style-${chipStyle}`]: true,
    }"
    :style="{
      'background-color': backgroundColor,
    }"
    @click="emit('click', $event)"
  >
    <ui-icon
      v-if="prependIcon"
      class="ui-chip__icon ui-chip__icon--prepend"
      :icon="prependIcon"
    />
    <div v-if="prependText" class="ui-chip__text-prepend">{{ prependText }}</div>

    <div class="ui-chip__text ml-4 ml-first-0" :style="{ color: contentColor }">
      <slot>{{ text }}</slot>
    </div>

    <div
      v-if="hasCloseButton"
      class="ui-chip__close ml-8"
      @click.stop="emit('close', $event)"
    >
      <ui-icon class="ui-chip__icon ui-chip__icon--close" icon="fas fa-times" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    chipStyle?: 'round' | '4px';
    prependText?: string;
    text?: string;
    contentColor?: string;
    prependIcon?: string;
    backgroundColor?: string;
    hasClose?: boolean | string;
    selected?: boolean;
  }>(),
  {
    chipStyle: '4px',
  },
);

const emit = defineEmits<{
  click: [event: MouseEvent];
  close: [event: MouseEvent];
}>();

const hasCloseButton = computed(
  () => props.hasClose === '' || Boolean(props.hasClose),
);
</script>

<style lang="scss">
.ui-chip {
  display: flex;
  flex-wrap: nowrap;
  background-color: var(--color-gray10);
  padding: 3px 8px;
  margin: 2px;

  &--selected {
    background-color: var(--color-green20);
  }

  &__text {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: var(--color-graphite);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__text-prepend {
    font-size: 12px;
    color: var(--color-graphite);
    font-weight: bold;
  }

  &__icon {
    font-size: 12px;
    margin-right: 2px;

    @at-root #{selector-append(&, & + '--prepend')} {
      color: var(--color-graphite);
    }

    @at-root #{selector-append(&, & + '--close')} {
      color: var(--color-red) !important;
    }
  }

  &__close {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}

.ui-chip-style-4px {
  border-radius: 4px;
}

.ui-chip-style-round {
  padding: 0 12px;
  border-radius: 28px;
  height: 16px !important;
  line-height: 16px;

  .ui-chip__text {
    font-size: 11px;
  }
}
</style>
